module.exports = __webpack_public_path__ + "img/complete.59dd68fb.svg";